import {
    Component,
    Inject,
    ViewEncapsulation,
} from '@angular/core';
import _ from 'lodash';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MemberStatus } from 'src/app/models/projects/submodels/members.model';
import { MembersService } from 'src/app/services/member.service';
import { ProofreadingMember } from 'src/app/models/proofreading-member.model';
import { Proofreading } from 'src/app/models/proofreading.model';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { AuthService } from 'src/app/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { LoaderService } from 'src/app/services/loader.service';
import { MembersProofreadingCrudModal } from '../members-proofreading-crud-modal/members-proofreading-crud-modal.component';
import { ExternStatePayloadFlag } from 'src/app/models/states.model';
import { ProjectService } from 'src/app/services/project.service';
import { State } from 'src/app/models/projects/project.model';


@Component({
    selector: 'app-members-proofreading-modal',
    templateUrl: './members-proofreading-modal.component.html',
    styleUrls: ['./members-proofreading-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MembersProofreadingModal extends ViewComponent {
    public readonly: boolean = false;

    protected _members: ProofreadingMember[] | undefined;
    get members(): ProofreadingMember[] {
        if (this._members) return this._members;
        return this.s_members.members || [];
    }
    get main_member(): ProofreadingMember | undefined {
        return this.members.find(member => member.hasApproDocument);
    }

    get current_approval_number(): number {
        return this.members?.filter(member => member.status === MemberStatus.ACCEPT || member.status === MemberStatus.REJECT).length || 0;
    }

    get total_approval_number(): number {
        return this.members?.filter(member => member.hasApproDocument || member.hasApproInfo).length || 0;
    }

    get proofreading(): Proofreading | undefined {
        return this.s_proofreading.current;
    }

    get current_order(): number {
        return this.proofreading?.current_order || 0;
    }

    get hasPreemptiveRefusal() {
        return this.members.filter(m => m.hasPreemptiveRight && m.status === MemberStatus.REJECT).length;
    }

    private get pr_restricted(): boolean {
        return !!this.proofreading && this.proofreading.state.hasPayloadFlag(ExternStatePayloadFlag.CUSTOMER_REVIEW);
    }


    private get state_archived(): boolean { return this.s_project.current?.state === State.ARCHIVED; }

    get locked() {
        return this.pr_restricted || this.state_archived || this.readonly;
    }

    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        @Inject(MAT_DIALOG_DATA) public data: { members?: ProofreadingMember[], readonly: boolean; },
        protected s_proofreading: ProofreadingService,
        protected s_project: ProjectService,
        protected s_members: MembersService,
        protected dialog: MatDialog,
    ) {
        super(route, router, s_alert, s_loader, s_auth);
        this._members = data.members;
        this.readonly = data.readonly;
    }


    editMembersModal() {
        this.dialog.open(MembersProofreadingCrudModal, {
            width: '80rem',
            data: {
                members: this.members,
                readonly: true
            },
        });
    }
}

